// UX88 (docs/build-briefs/UX88-all-named-lists-alphabetical.md, DEC-339):
// pure builders for the lists of NAMED things whose order used to be the
// stored or server order. DOM-free so node:test can import them (admin.ts and
// main.ts cannot be imported without a DOM). Every builder sorts by the
// SHOWN label through nameSort.ts at render time and never changes a stored
// order column.

import { sortOptions, type NamedOption } from "./nameSort.ts";

/** The roles a person can be given: the tenant's switched-on roles, shipped
 * and custom together, A to Z by name. Falls back to the shipped roles until
 * the tenant's roles have loaded. */
export function roleOptionsFrom(
  tenantRoles: readonly { role: string; label: string; active: boolean }[],
  shipped: readonly NamedOption[],
): NamedOption[] {
  const active = tenantRoles.filter((role) => role.active);
  if (active.length === 0) {
    return sortOptions(shipped);
  }
  return sortOptions(active.map((role) => ({ value: role.role, label: role.label })));
}

/** Count sections as a PICKER (assigning an item to a section): "No section"
 * first, then the active sections A to Z. The count WALK sequence through
 * sections is the location's configured order and does not use this. */
export function countSectionPickerOptions(
  sections: readonly { id: string; name: string; active: boolean }[],
): NamedOption[] {
  return sortOptions(
    [
      { value: "", label: "No section" },
      ...sections
        .filter((section) => section.active)
        .map((section) => ({ value: section.id, label: section.name })),
    ],
    (option) => option.value === "",
  );
}
